<template>
  <div>
      <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div class="px-4 py-3 sm:px-0">
          <div class="flex flex-col">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <DataTable
                    :value="members"
                    :paginator="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                    :rows="10"
                    :rowsPerPageOptions="[10, 20, 50]"
                    :auto-layout="true"
                    stripedRows
                    class="p-datatable-striped admin-projects-table"
                  >
                    <Column field="color" header="AVATAR">
                      <template #body="slotProps">
                        <Avatar
                          :image="avatar_face"
                          shape="circle"
                          class="p-1"
                          :style="{ 'background-color': slotProps.data.color }"
                        />
                      </template>
                    </Column>
                    <Column field="username" header="NOM"></Column>
                    <Column field="email" header="EMAIL"></Column>
                  </DataTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Avatar from "primevue/avatar";
import avatar_face from "~/assets/img/avatars/face-1.svg";

export default {
  components: {
    DataTable,
    Column,
    Avatar,
  },
  data () {
    return {
    avatar_face: avatar_face
    }
  },
  props: {
    members: Array
  }
}
</script>
